import React from 'react';
import moment from 'moment';
import { Spring } from 'react-spring';
import Loading from '../../components/Loading/Loading';
import HeaderComponent from '../../components/Header';
import { notesAction } from '../../store/actions';
import { connect } from 'react-redux';
import Footer from '../../components/Footer/footer';
import { history } from '../../helpers';
import '../../static/css/styles.css';
import { constants } from '../../Constants';
import Swal from 'sweetalert2';
import { noteMasterView } from '../../helpers/ConstantID';

class Note extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			note: [],
		};
	}

	componentDidMount() {
		const user_id = this.props.user.user_id;
		this.props.getNotes(user_id);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.note.deleteNote) {
			const user_id = this.props.user.user_id;
			this.props.getNotes(user_id);
		}

		this.setState({
			note: nextProps.note.notes,
		});
	}
	View = (data) => {
		this.props.showNote(data);
		history.push(`/noteview/${data.id}`);
	};
	deleteNote = (note_id) => {
		const user_id = this.props.user.user_id;
		Swal.fire({
			title: 'Are you sure?',
			text: 'You want to delete your note?',
			type: 'warning',
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: '#36A692',
			cancelButtonColor: '#d33',
			cancelButtonText: 'No',
			confirmButtonText: 'Yes',
		}).then((result) => {
			if (result.value) {
				this.props.deleteNote(note_id);

				Swal.fire('Saaya Health', 'Your Note has been deleted!', 'success');
			} else {
			}
		});
	};

	render() {
		const { whitelabel } = this.props;
		if (this.props.note.loading === false) {
			const sortedNotes = [...this.state.note].sort((a, b) => new Date(b.date_created) - new Date(a.date_created));
			return (
				<div className="sh-layout hoffen-block">
					<HeaderComponent />

					<div className="sh-patient-note-comp sh-gnrl-width">
						{/* Welcome Note */}
						<div className="sh-gnrl-welcome-note">
							<h2 className="sh-gnrl-welcome">{constants.NOTES_TEXT.toUpperCase()}</h2>
						</div>

						{/* Session Div */}
						<div className="sh-gnrl-container">
							{Array.isArray(this.props.note.notes) && this.state.note.length > 0 ? (
								<div className="sh-gnrl-cont-content">
									{/* Header for counsellor */}
									<div className="sh-gnrl-cc-row">
										<div className="sh-gnrl-col-1 sh-mble-col-1">
											{this.props.user.role === 1 ? (
												<span className="sh-gnrl-cchc-main-head">
													{whitelabel && whitelabel[0]
														? whitelabel[0].producer_role
														: constants.COUNSELLOR}
												</span>
											) : (
												<span className="sh-gnrl-cchc-main-head">
													Name of{' '}
													{whitelabel && whitelabel[0]
														? whitelabel[0].consumer_role
														: constants.PATIENT}
												</span>
											)}
										</div>
										<div className="sh-gnrl-col-2 sh-mble-col-3">
											<span className="sh-gnrl-cchc-main-head">When</span>
										</div>
										<div className="sh-gnrl-col-1 sh-mble-col-1">
											<span className="sh-gnrl-cchc-main-head">
												<i className="fa fa-bars"></i>
											</span>
										</div>
									</div>

									{/* Main content Counsellor */}
									{Array.isArray(sortedNotes) && sortedNotes.length > 0 && sortedNotes.map((v, i) => {
										return (
											<div className="sh-gnrl-cc-row" key={i}>
												<div className="sh-gnrl-col-1 sh-mble-col-1">
													{this.props.user.role === 0 ? (
														<span className="sh-gnrl-cchc-main-title">
															{v.patient || 'N/A'}
														</span>
													) : (
														<span className="sh-gnrl-cchc-main-title">
															{v.counsellor || 'N/A'}
														</span>
													)}
												</div>
												<div className="sh-gnrl-col-2 sh-mble-col-3">
													<span className="sh-gnrl-cchc-main-title">
														{moment(v.date_created)
															.format('ddd DD MMM YYYY hh:mm:ss A')
															.toLocaleString('en-US', {
																hour: 'numeric',
																hour12: true,
															})}
													</span>
												</div>
												<div className="sh-gnrl-col-1 sh-mble-col-unset">
													<div className="sh-gnrl-btn-container">
														<button
															className="sh-btn-view sh-gnrl-btn-session"
															id={noteMasterView.sh_nmv_view_btn}
															onClick={() => this.View(v)}
														>
															<span className="sh-text-icon">
																{constants.VIEW_TXT}
															</span>
															<span className="icon"></span>
														</button>
														<button
															className="sh-btn-cancel sh-gnrl-btn-session"
															id={noteMasterView.sh_nmv_delete_btn}
															onClick={() => this.deleteNote(v.id)}
														>
															<span className="sh-text-icon">
																{constants.DELETE_TXT}
															</span>
															<span className="icon"></span>
														</button>
													</div>
												</div>
											</div>
										);
									})}
								</div>
							) : (
								<h3 className="sh-gnrl-empty-note">{constants.EMPTY_NOTES_TXT}</h3>
							)}
						</div>
					</div>

					<Footer />
				</div>
			);
		} else {
			return <Loading />;
		}
	}
}

function mapStateToProps(state) {
	const { session, auth, alert, note } = state;
	const { appointments } = state.appointments;
	const { user } = auth;
	const { whitelabel } = state.whitelabel;
	return {
		user,
		alert,
		appointments,
		session,
		note,
		whitelabel,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		getNotes: () => {
			dispatch(notesAction.getNotes());
		},
		showNote: (data) => {
			dispatch(notesAction.showNote(data));
		},
		deleteNote: (note_id) => {
			dispatch(notesAction.deleteNote(note_id));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Note);



// WEBPACK FOOTER //
// ./src/screens/NoteScreen/index.js